import pagesNames from "../../../constants/pages-names";

const socialPageDataAr = {
    mainHeader : "الأثر الاجتماعي ",
    borderSection : {
        title : "الهدف العام",
        subtitle : "الاضطلاع بدور رائد في مسيرة بناء مجتمع يتسم بالشمول والتنوع بما يُحقق تأثيراً إيجابياً لدى أصحاب المصلحة",
    },
    paragraphOne : "يتمثل الجانب الاجتماعي في استراتيجية الحوكمة البيئية والاجتماعية والمؤسسية في السعي لإحداث آثار اجتماعية بعيدة المدى بالمجتمع. ولتحقيق هذا الهدف الأسمى، تنطوي مشروعات التنمية الاجتماعية لدينا على نطاق عريض من أنشطة التنمية البشرية. وفي خضم هذا العالم الذي يستشري فيه انعدام المساواة، نحرص على أن تكون مساهمتنا على صعيد استعادة الكرامة الإنسانية من خلال دعم الاحتياجات الأساسية وتمكين الفئات المهمشة بالمجتمع بالمهارات اللازمة لممارسة حياة طبيعية.",
    paragraphTwo : "تدعو مجموعة الأمم المتحدة للتنمية المستدامة إلى دعم التنمية البشرية، وهي الدعوة التي تتناغم معها القيم المؤسسية لبنك الأول المتمثلة في الشمول والتنوع. ويتأتى دعم البنك لمفهوم الشمول في شكل المشاريع الاجتماعية التي تعمل على تمكين المرأة وذوي الإعاقة. علاوة على ذلك، فإننا ندرك تمام الإدراك أن الشرائح الأخرى بمجتمعنا، مثل الفئات المحرومة، يجب عدم تهميشها . وتحقيقاً لهذه الغاية، فإننا نسهم في دعم ذوي الإعاقة والأسر منخفضة الدخل وكذلك الأرامل والأيتام والأطفال ذوي الاحتياجات الخاصة.",
    paragraphThree : "ولا تتوقف مهمتنا عند هذا الحد، بل تتخطى مجرد الاحتياجات الأساسية وتهدف إلى ضمان تحقيق أحلام الناس وآمالهم. تكمن العوامل الداعمة لجوانب تمكين المهارات اللازمة في قلب المنهجية التي نتبعها لتمكين الأفراد والجماعات بالمجتمع، حيث نشارك في المبادرات التي تستهدف تنمية مهارات ريادة الأعمال بما يدعم قادة الأعمال المؤسسية الناشئة من فئة الشركات متناهية الصغر والصغيرة والمتوسطة بالمملكة، وخاصة من الشباب والنساء.",
    sectionOne : {
        title : "مجالات التركيز",
        cards : [
            {
                icon : "two-hands.svg",
                title : "التنوع",
                subtitle : "تمكين المرأة وذوي الإعاقة",
            },
            {
                icon : "hand-shaking.svg",
                title : "سد الفجوة في المدخرات على المستوى الإقليمي ",
                subtitle : "التعليم والوعي المالي",
            },
            {
                icon : "esg.svg",
                title : "تطوير الممارسات البيئية والاجتماعية والحوكمة المؤسسية والسوق المالي المستدام",
                subtitle : "مشاركة أصحاب المصلحة",
            },
            {
                icon : "digital.svg",
                title : "التحول الرقمي لدعم توفير رحلة مالية مستدامة للعملاء",
                subtitle : "الوصول إلى الخدمات المالية والأمن السيبراني",
            },
        ]
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ],
    tabsView : {
        titles : [
            "التنوع",
            "سد الفجوة في المدخرات على المستوى الإقليمي",
            "تطوير الممارسات البيئية والاجتماعية والحوكمة المؤسسية والسوق المالي المستدام",
            "التحول الرقمي",
            "المبادرات المجتمعية",
            "مواردنا البشرية: حجر الأساس لنجاح البنك",
        ],
    }
}

export default socialPageDataAr;